import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import _partial from 'lodash/partial'
import { List } from 'immutable'
import { getBoundActions } from '../../actions/index'
import {
  upstreamContextOnClick as upstreamContextClick,
} from '../../services/upstream-context/index'
import { connect as connectStaticText } from '../StaticText/connect'
import {
  EVENT_SPOTLIGHT_PLAY_TOGGLE,
  EVENT_SPOTLIGHT_AUDIO_TOGGLE,
} from '../../services/event-tracking/index'
import DropInVideoPlayer from '../DropInVideoPlayer/index'
import {
  BASIC_CONTROLS,
  BASIC_CONTROL_OPTIONS_VOLUME,
  BASIC_CONTROL_OPTIONS_PLAYBACK,
  BASIC_CONTROL_OPTIONS_VOLUME_LABEL,
  BASIC_CONTROL_OPTIONS_PLAYBACK_LABEL,
} from '../DropInVideoPlayer/DropInVideoPlayer'
import SpotlightMetadata from '../SpotlightMetadata/index'
import SpotlightActionButtons from '../SpotlightActionButtons/index'
import { handlePlayerControlButtonClick } from '../Spotlight/utils'
import { getPrimary } from '../../services/languages/index'

class SpotlightTrailerBannerV2 extends Component {
  componentDidMount () {
    const { props } = this
    const { mediaId, auth, user } = props
    props.getMediaData({ id: mediaId, auth, user })
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const {
      mediaId, auth, user,
    } = props

    if (prevProps.mediaId !== mediaId) {
      props.getMediaData({ id: mediaId, auth, user })
    }
  }

  getUpstreamContextOnClick = () => {
    const { props } = this
    const {
      upstreamContext,
      setUpstreamContext,
    } = props

    return _partial(
      upstreamContextClick,
      _partial.placeholder,
      { upstreamContext, setUpstreamContext },
    )
  }

  sendVolumeToggleEvent = (isMuted) => {
    const { props } = this
    handlePlayerControlButtonClick({
      props,
      eventName: EVENT_SPOTLIGHT_AUDIO_TOGGLE,
      eventValue: isMuted,
    })
  }

  sendPlaybackToggleEvent = (isPlaying) => {
    const { props } = this
    handlePlayerControlButtonClick({
      props,
      eventName: EVENT_SPOTLIGHT_PLAY_TOGGLE,
      eventValue: isPlaying,
    })
  }

  render () {
    const {
      props,
      sendVolumeToggleEvent,
      sendPlaybackToggleEvent,
      getUpstreamContextOnClick,
    } = this
    const {
      data,
      media,
      user,
      viewportWidth,
      staticText,
    } = props
    const upstreamContextOnClick = getUpstreamContextOnClick()
    const mediaId = data.getIn(['preview', 'id'])
    const userLanguage = getPrimary(user.getIn(['data', 'language'], List()))
    const contentType = data.get('contentType')
    const displayType = data.get('displayType')

    const className = [
      'spotlight-trailer-banner-v2',
      `spotlight-trailer-banner-v2--${userLanguage}`,
      `spotlight-trailer-banner-v2--${contentType}`,
      displayType ? `spotlight-trailer-banner-v2--${displayType}` : null,
    ].filter((cls) => !!cls).join(' ')

    // for anything 767 and below, render static spotlight
    if (viewportWidth <= 767 || !mediaId || mediaId === -1 || mediaId !== media.get('id')) {
      return (
        <div className="spotlight-trailer-banner-v2">
          {this.props.children}
        </div>
      )
    }

    // for anything above 767, render the video
    return (
      <div className={className}>
        <div className="spotlight-trailer-banner-v2__overlay"/>
        <div className="spotlight-trailer-banner-v2__overlay-darken" />
        <div className="spotlight-trailer-banner-v2__content">
          <SpotlightMetadata {...props} upstreamContextOnClick={upstreamContextOnClick} />
          <SpotlightActionButtons {...props} upstreamContextOnClick={upstreamContextOnClick} />
        </div>
        <div className="spotlight-trailer-banner-v2__video">
          <DropInVideoPlayer
            autoplay
            loop
            controls={{
              type: BASIC_CONTROLS,
              visibleControls: [
                BASIC_CONTROL_OPTIONS_VOLUME,
                BASIC_CONTROL_OPTIONS_PLAYBACK,
                BASIC_CONTROL_OPTIONS_VOLUME_LABEL,
                BASIC_CONTROL_OPTIONS_PLAYBACK_LABEL,
              ],
            }}
            mediaId={mediaId}
            mediaWasFetched
            optionalMuteToggleFunction={sendVolumeToggleEvent}
            optionalPlaybackToggleFunction={sendPlaybackToggleEvent}
            withoutControls
            customVolumeOnLabel={staticText.getIn(['data', 'mute'])}
            customVolumeOffLabel={staticText.getIn(['data', 'unmute'])}
          />
        </div>
      </div>
    )
  }
}

SpotlightTrailerBannerV2.propTypes = {
  data: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  mediaId: PropTypes.number,
  page: PropTypes.object,
  auth: ImmutablePropTypes.map.isRequired,
  language: PropTypes.string,
  upstreamContext: ImmutablePropTypes.map,
  setUpstreamContext: PropTypes.func,
  getMediaData: PropTypes.func,
  viewportWidth: PropTypes.number,
  setEventDefault: PropTypes.func,
  useGraphQLData: PropTypes.bool,
  section: ImmutablePropTypes.map,
}

export default compose(
  connectRedux(
    (state, props) => {
      const { data } = props

      return {
        auth: state.auth,
        user: state.user,
        media: state.media,
        viewportWidth: state.app.getIn(['viewport', 'width']),
        contentType: data.get('contentType'),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUpstreamContext: actions.upstreamContext.setUpstreamContext,
        getMediaData: actions.media.getMediaData,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
  connectStaticText({ storeKey: 'spotlightTrailerBanner' }),
)(SpotlightTrailerBannerV2)
